import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { useTranslationContext } from "../../hooks/translations/translationsProvider";
import { GREEN_LOGO, GREEN_MAIN } from "../../theme/colors";
import { Trans } from "react-i18next";
import { EditableTextArea } from "./EditableTextArea";
import { useUserContext } from "../../hooks/auth/UserProvider";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const PresentCircuit:React.FC = () =>{
    const {isForbidden} = useUserContext();
    const {t} = useTranslationContext();
    const navigate = useNavigate();

    useEffect(() => {
        if(isForbidden){
            navigate('/');
        }
    }, [isForbidden]);
    
    return(
        !isForbidden ? <Box sx={{width:'100%', overflow: 'hidden', maxWidth: '100%', fontFamily:'poppins', color:GREEN_MAIN }}>
            <Typography fontSize='0.9em' textAlign='justify' paddingBottom={5}>
                <Trans
                    i18nKey='present-circuit-disclamer'
                    compoments = {{
                        br: ( 
                            <br />
                        ),
                        strong: (
                            <strong></strong>
                        )
                    }}
                />
            </Typography>

            <EditableTextArea />

        </Box> : <></>
    );
}